import $ from 'jquery';
import 'slick-carousel'

let galleryCarousel = {
  initialize: function () {
    $('[data-carousel]').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      prevArrow: '.c-gallery__button--prev',
      nextArrow: '.c-gallery__button--next',
      dots: true,
      appendDots: '.c-gallery__dots',
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 979, // CSS breakpoint 'desktop' - 1px
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4
          }
        },
        {
          breakpoint: 739, // CSS breakpoint 'tablet' - 1px
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 479, // CSS breakpoint 'mobile' - 1px
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1
          }
        }
      ]
    });
  }
};

galleryCarousel.initialize();
